import Marquee from "react-fast-marquee";

const ITEMS = ["Health", "Life", "Motor", "Property & Fire", "Travel", "Marine & Cargo"];

export const MarqueeStrip = () => (
  <section className="bg-ink py-8 overflow-hidden" data-testid="marquee">
    <Marquee speed={45} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="text-4xl sm:text-6xl font-extrabold tracking-tighter text-zinc-700 px-8">
            {item}
          </span>
          <span className="text-forest-light text-4xl sm:text-6xl">•</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default MarqueeStrip;
